<template>
  <div>
    <va-modal
      :value="showModal"
      id="checkupReportPdfModalOptions"
      ref="checkupReportPdfModalOptions"
      size="large"
      :showOkay="true"
      @ok="handleOk"
      @cancel="$emit('cancel')"
      :okText="$t('modal.confirm')"
      :cancelText="$t('leads.back')"
      :noDismiss="true"
      :no-outside-dismiss="false"
      :okDisabled="!canSubmit"
      :fixedLayout="true">
      <div slot="header" class="modal-title d-flex justify--space-between pb-0 mb-0">
        <span>{{$t('checkup_plus.reports.report_options')}}</span>
      </div>

      <div class=" va-card p-2 pb-4">
        <div class="row">
          <h4>{{$t('checkup_plus.reports.historical_data.title')}}</h4>
        </div>

        <div class="row form-row evollu-form">
          <div class="col-12 col-md-4 mr-3">
            <range-date-picker
              id="periodPicker"
              :label="$t('statistics2.hear.sublabels.period')"
              v-model="filters.dates"
              :placeholder="this.$t('agenda.reports.date_range')"
              :config="{ maxInterval: { value: 12, unit: 'months' }, maxDate: moment().toDate(), dateFormat: 'Y/m/d'}"
              :clearable="true"
            />
          </div>

          <div class="col-12 col-md-4 mr-3">
            <va-input
              :label="$t('historystats.registos')"
              id="maxRecordsInput"
              v-model="filters.maxRecords"
              :placeholder="$t('historystats.registos')"
              type="number"
              :min="0"
              :max="100"
              :step="1"
            />
          </div>
        </div>
      </div>



    </va-modal>
  </div>

</template>

<script>
import RangeDatePicker from '@/components/common/RangeDatePicker.vue';

export default {
  components: { RangeDatePicker },
  props: {
    actionType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showModal: false,
      filters: {
        dates: {
          //start: this.moment().subtract(12, 'month').format('YYYY/MM/DD'),
          //end: this.moment().format('YYYY/MM/DD')
          start: null,
          end: null
        },
        maxRecords: 10,
      },
      canSubmit: true
    };
  },
  mounted() {
    this.showModal = true
  },
  methods: {
    handleOk: function() {
      this.$emit('reportOptionsConfirm', {filters: {...this.filters, actionType: this.actionType}})
      this.showModal = false
    },
  },
  watch: {
    'filters.maxRecords': {
      handler: function(val) {
        if(val < 0) {
          this.canSubmit = false
        } else {
          this.canSubmit = true
        }

      },
    }
  }
};
</script>

<style scoped lang="scss">
table {
  border-collapse: separate;
  border-spacing: 0;
}

th, td {
  border: 1px solid #b4b4b4;
  padding: 5px 10px;
}

th {
  font-weight: bold;
  background-color: #d5d5d5;
}

th:first-child {
  border-top-left-radius: 8px;
}

th:last-child {
  border-top-right-radius: 8px;
}

tr:last-child td:first-child {
  border-bottom-left-radius: 8px;
}

tr:last-child td:last-child {
  border-bottom-right-radius: 8px;
}

</style>
